// extracted by mini-css-extract-plugin
export default {"mft":"mft"};